import React, { useContext } from 'react'
import { Link } from 'react-router-dom'

import HelloIntroBox from '../../../components/IntroBox'
import BackToPortal from '../../../components/BackToPortal'

const ManageClientSidebar = () => {
    return (
        <>
            <HelloIntroBox type="IPSA" />

            <ul className="button-list">
                <li>
                    <Link to="/clients" className="btn arrow-btn-left">
                        BACK TO CLIENTS<span></span>
                    </Link>
                </li>
                <li>
                    <BackToPortal />
                </li>
            </ul>
        </>
    )
}

export default ManageClientSidebar
